<style>

.contact .section-shaped .shape-style-1.shape-primary.wsu {
    /* uigradients.com */
    background: #042D98;
    background-image: url('./../assets/img/vortex.jpg');
    background-repeat: no-repeat;
    background-position: left;
    background-size: cover;
    -webkit-box-shadow: 0px 1px 23px 0px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0px 1px 23px 0px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 1px 23px 0px rgba(0, 0, 0, 0.75);
}

.contact .title {
    color: #ffffff;
}

.contact .subtitle {
    color: #e0e1e2;
}

.contact .contact-body {
    min-height: 700px;
}

.contact .loading {
    background-color: #f7f7f7;
}

.contact .link {
    cursor: pointer;
}

.contact .modal-content {
    color: #fff;
    background: #3a7bd5;  /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #3a6073, #3a7bd5);  /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #3a6073, #3a7bd5); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

}

.contact .modal-body {
    padding: 1rem;
}

.contact .modal-footer {
    border-top: 0;
    padding: 1rem;
}

.form-control {
    color: #333333;
}

@media(max-width:575px) {}

@media(min-width:576px) and (max-width:767px) {}

@media(min-width:768px) and (max-width:991px) {}

@media(min-width:992px) and (max-width:1199px) {}

@media(min-width:1200px) {}

</style>

<template>

<div class="contact">
    <section class="section section-shaped my-0 pb-xs">
        <div class="shape shape-style-1 shape-primary wsu">
        </div>
        <div class="container">
            <div class="row my-0 py-0">
                <div class="col-lg-12">
                    <h1 class="title text-center my-0 py-0"><center>EDUCATIONAL DATABASE</center></h1>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-2">&nbsp;</div>
                <div class="col-lg-8">
                    <p class="subtitle" v-html="subtitle"></p>
                </div>
            </div>
        </div>
    </section>
    <section class="section faw-body">
        <div class="container">
            <div class="row">
                <div class="col-lg-2"></div>
                <div class="col-lg-8" v-if="!loading">
                    <h1>CONTACT</h1>
                    <span class="text-uppercase text-primary">{{title}}</span>
                </div>
                <div class="col-lg-8 loading" v-if="loading">
                    <h1>&nbsp;</h1>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-lg-2"></div>
                <div class="col-lg-8" v-if="!loading" v-html="description"></div>
                <div class="col-lg-8 loading" v-if="loading">
                    <template v-for="i in (1, 8)">
                        <p>&nbsp;</p>
                    </template>
                </div>
            </div>
            <div class="row my-5">
                <div class="col-lg-2"></div>
                <div class="col-lg-8" v-if="!loading">
                    <form id="contact_form" v-on:submit.prevent="submitForm" action="">
                        <div class="form-group">
                            <label for="name">Name</label>
                            <input v-model="name" v-on:blur="isValidName" class="form-control" name="name" type="text" />
                        </div>
                        <div class="form-group">
                            <label for="email">Email</label>
                            <input v-model="email" v-on:blur="isValidEmail" class="form-control" name="email" type="email" />
                        </div>
                        <div class="form-group">
                            <label for="message">Message</label>
                            <textarea v-model="message" v-on:blur="isValidMessage" class="form-control" name="message"></textarea>
                            <small>
                                <span v-bind:style="[(message.split(' ').join('').length <= maxLength) ? {'color': '#ccc'} : {'color': 'red', 'fontSize': '1.5rem'}]">
                                    {{message.split(' ').join('').length}}
                                </span>
                                <span style="color:#ccc">&nbsp;/&nbsp;{{maxLength}}</span>
                            </small>
                        </div>
                        <button type="submit" class="btn btn-primary">{{btn_send}}</button>
                    </form>
                </div>
            </div>
        </div>
    </section>
    <b-modal v-model="modal_alert" size="sm" hide-header>
        <p class="my-4 text-center">{{modal_msg}}</p>
        <div slot="modal-footer" class="w-100">
            <b-btn class="float-right" variant="primary" @click="modal_alert=false">
                OK
            </b-btn>
        </div>
    </b-modal>
</div>

</template>

<script>

import axios from 'axios'
import {
    BadgerAccordion, BadgerAccordionItem
}
from 'vue-badger-accordion'

export default {
    components: {
        BadgerAccordion,
        BadgerAccordionItem
    },
    created() {
        window.scrollTo(0, 0);
    },
    mounted() {
        if(this.$store.state.subtitle_store)
            this.subtitle = this.$store.state.subtitle_store
        else this.get_page_subtitle()
        this.get_page()
    },
    methods: {
        get_page_subtitle() {
            this.error = null
            axios.get(this.api + 'page/subtitle-pages')
                .then(response => {
                    this.subtitle = response.data.content
                    this.$store.state.subtitle_store = this.subtitle
                })
        },
        get_page() {
                this.error = null
                this.loading = true
                axios.get(this.api + 'page/contact')
                    .then(response => {
                        this.loading = false
                        this.title = response.data.title
                        this.description = response.data.content
                        // document.getElementsByTagName('meta')["description"].content = this.description.substr(0, 150);
                    })
            },
            isValidName: function() {
                var valid = this.name.split(' ').join('').length > 0;
                return valid;
            },
            isValidEmail: function() {
                var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                var valid = re.test(this.email);
                return valid;
            },
            isValidMessage: function() {
                var valid = (this.message.split(' ').join('').length > 0) &&
                    (this.message.split(' ').join('').length <= this.maxLength);
                return valid;
            },
            submitForm: function() {
                this.btn_send = 'SENDING ...'
                if (!this.isValidName()) {
                    this.btn_send = 'SEND'
                    this.modal_msg = 'Name is invalid!'
                    this.modal_alert = true
                    return
                }
                if (!this.isValidEmail()) {
                    this.btn_send = 'SEND'
                    this.modal_msg = 'E-mail is invalid!'
                    this.modal_alert = true
                    return
                }
                if (!this.isValidMessage()) {
                    this.btn_send = 'SEND'
                    this.modal_msg = 'Message is invalid!'
                    this.modal_alert = true
                    return
                }
                let url = this.mailapi + 'sendmail.php?key=BuibWp7XjTZpWTklyktoXX9hXOfh7800&name=' + this.name + '&email=' + this.email + '&message=' + this.message;
                axios.get(url)
                .then(response => {
                    this.mail_sent()
                })
            },
            mail_sent(message) {
                this.modal_msg = 'Tank tou for your contact!'
                this.modal_alert = true
                this.name = ''
                this.email = ''
                this.message = ''
                this.btn_send = 'SEND'
            }
    },
    head: {
        title: function () {
          return {
            inner: 'CONTACT'
          }
        }
    },
    data() {
        return {
            api: require('../../package.json').api,
            mailapi: require('../../package.json').mailapi,
            subtitle: '',
            error: null,
            loading: false,
            title: '',
            description: '',
            name: '', // data for the name on the form
            email: '', // data for the email on the form
            message: '', // data for the message on the form
            maxLength: 140, // maximum length of the form message
            modal_alert: false,
            modal_msg: '',
            btn_send: 'SEND'
        }
    }
}

</script>



// WEBPACK FOOTER //
// src/views/Contact.vue